@if (activeLoader) {
  <app-fullscreen-loader
    [deviceId]="currentDeviceId"
    [current]="queueCurrent"
    [max]="queueMax"
  >
  </app-fullscreen-loader>
}
<div class="device-flash-container">
  <div class="device-flash-header">
    <div class="device-flash-count">
      @if (nbFlashedDevices > -1) {
        <div class="notranslate">
          <div class="devicesCountNumber">{{ nbFlashedDevices }}</div>
        </div>
      }
      @if (nbFlashedDevices > -1) {
        <div class="devicesCountTitle">Devices</div>
      }
    </div>
    <div class="dropdown-container">
      @if (cameraEnabled && listCameras?.length) {
        <select
          class="device-flash-camera-select"
          [(ngModel)]="selectedCamera"
          (ngModelChange)="onCameraChange($event)"
        >
          @for (camera of listCameras; track camera) {
            <option [value]="camera.id">
              {{ camera.label }}
            </option>
          }
        </select>
      }
    </div>
  </div>

  @if (!cameraEnabled && cameraError === "") {
    <button
      mat-raised-button
      (click)="showCamera()"
      class="showQRBtn"
      [disabled]="!permissionAsked"
    >
      <img class="QRIcon" src="assets/qr-code.png" />
    </button>
  }
  <div class="cameraHolder" [style]="cameraStyle">
    <div class="wrapper" [style.width.%]="qrCodeWidth">
      <app-qr-scanner
        [cameraEnabled]="cameraEnabled"
        [cameraActive]="selectedCamera"
        [isFlashOn]="isFlashOn"
        (camerasList)="setCamerasList($event)"
        (flashCompatible)="onFlashCompatible($event)"
        (scanSuccess)="parseQRResult($event)"
      ></app-qr-scanner>
      @if (cameraEnabled && isFlashAllowed) {
        <img
          class="flash"
          src="{{ FLASH_PATH }}"
          (click)="toggleFlash()"
          [style.background-color]="
            isFlashOn ? 'rgba(150, 150, 150, .5);' : 'rgba(0, 0, 0, .5);'
          "
        />
      }
      @if (cameraEnabled) {
        <img class="zoom" (click)="close()" src="assets/close.svg" />
      }
    </div>
  </div>

  @if (cameraError !== "") {
    <div class="cameraError">
      <p>
        {{ cameraError }}
      </p>
      <img
        class="reload"
        (click)="reloadPermissions()"
        src="assets/reload.png"
      />
    </div>
  }

  @if (cameraEnabled && !error && !success) {
    <p class="scanning">Scanning</p>
  }

  @if (success.length && !error.length) {
    <div class="success">
      <button mat-icon-button class="flasher-msg-reset" (click)="resetMsgs()">
        <img src="assets/delete_grey.svg" />
      </button>
      @for (msg of success; track $index) {
        <p>
          {{ msg }}
        </p>
      }
    </div>
  }

  @if (error.length) {
    <div class="error">
      <button mat-icon-button class="flasher-msg-reset" (click)="resetMsgs()">
        <img src="assets/delete_grey.svg" />
      </button>
      @if (error.length > 1) {
        <p>BATCH CANCELLED :</p>
      }
      @for (msg of error; track $index) {
        <p>
          {{ msg }}
        </p>
      }
    </div>
  }

  @if (!cameraEnabled) {
    <div class="formFieldDevice" floatLabel="never">
      <mat-icon class="inputIcon" svgIcon="search_grey" (click)="handleInput()"
        >search</mat-icon
      >
      <input
        class="inputDevice"
        type="text"
        placeholder="Enter device ID"
        (click)="close()"
        aria-label="String"
        matInput
        name="inputDeviceId"
        (keydown.enter)="handleInput()"
        [(ngModel)]="inputDeviceId"
      />
    </div>
  }
</div>
